import script from "./editServerList.vue?vue&type=script&lang=ts&setup=true"
export * from "./editServerList.vue?vue&type=script&lang=ts&setup=true"

import "./editServerList.vue?vue&type=style&index=0&id=6480b120&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6480b120"]])

export default __exports__